import React from 'react';

import { useTranslation } from 'react-i18next';

import { Faq } from '@entities/faq';
import { ShopFilters, ShopPagination, ShopItemsList } from '@entities/shop';
import { useShopData } from '@entities/shop/hooks/use-shop-data';

import prj4BannerImg from '@assets/images/shop/promo-gift-prj4.webp';
import sk2BannerImg from '@assets/images/shop/promo-gift-sk2.webp';
import nguBannerImg from '@assets/images/shop/promo-gift.png';

import { Loader } from '@components/loader';
import { Pagination } from '@components/pagination';

import { config } from '@/config.ts';

// import { ShopAnnouncementBar } from './components/announcement-bar';
import { ShopOneLineBanner } from './components/shop-one-line-banner';
import * as Styled from './shop.styled';

export type BannerPropsType = Record<string, { text: string; image: string; colorStart: string; colorEnd: string }>;

const Shop: React.FC = () => {
	const { t } = useTranslation('');
	const {
		filtersState,
		accumulatedItems,
		isLoadingMore,
		isInitialLoad,
		cachedCategories,
		categoryTags,
		isLoading,
		hasItems,
		hasMore,
		totalItems,
		displayedItems,
		shopData,
		handleFiltersChange,
		handleLoadMore,
		handlePagination
	} = useShopData();

	const isNgu3 = config.BRAND === 'ngu3';
	const isSk2 = config.BRAND === 'sk2';
	const isRockets = config.BRAND === 'rockets';
	// const isRockets = config.BRAND === 'rockets';
	// const isBlitz = config.BRAND === 'blitz';

	const isExternalBrand = isNgu3 || isSk2 || isRockets;

	const isPagination: boolean = shopData?.meta?.enabled_pagination || false;

	if (isInitialLoad) {
		return (
			<>
				<Loader />
			</>
		);
	}

	const bannerDataConfig: BannerPropsType = {
		ngu3: {
			text: t('shop:closingText'),
			image: nguBannerImg,
			colorStart: '#600FA9',
			colorEnd: '#FD4C0A'
		},
		prj4: {
			text: t('shop:notAvailable'),
			image: prj4BannerImg,
			colorStart: '#1A1A04',
			colorEnd: '#8E8E04'
		},
		sk2: {
			text: t('shop:notAvailable'),
			image: sk2BannerImg,
			colorStart: '#081712',
			colorEnd: '#099189'
		}
	};

	return (
		<>
			{/* Add banner here */}
			{/* <ShopAnnouncementBar />*/}
			{isExternalBrand && <ShopOneLineBanner {...bannerDataConfig[config.BRAND]} />}
			{isSk2 && <Styled.Title>{t('bonus_shop')}</Styled.Title>}

			<ShopFilters
				categories={cachedCategories}
				categoryTags={categoryTags}
				filtersState={filtersState}
				onFiltersChange={handleFiltersChange}
				isLoading={isLoading && !isInitialLoad}
			/>
			<ShopItemsList items={accumulatedItems} categories={cachedCategories} isLoadingMore={isLoadingMore} />

			{isPagination ? (
				shopData &&
				(shopData?.pagination?.total_pages || 0) > 1 && (
					<Styled.PaginationRow>
						<Pagination
							currentPage={shopData?.pagination?.current_page || 1}
							totalPages={shopData?.pagination?.total_pages || 1}
							onPageChange={handlePagination}
						/>
					</Styled.PaginationRow>
				)
			) : (
				<ShopPagination
					hasItems={hasItems}
					hasMore={hasMore}
					isLoading={isLoading}
					onLoadMore={handleLoadMore}
					totalItems={totalItems}
					displayedItems={displayedItems}
				/>
			)}

			{isSk2 && <Faq isClosed />}
		</>
	);
};

export default Shop;
